function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}import styles from './canvas-loader.scss';
import template from './canvas-loader.html';

export var CanvasLoaderComponent = {
  template: template,
  styles: styles,
  bindings: {
    loader: '<' },

  controller:
  function CanvasLoaderComponentController() {
    "ngInject";_classCallCheck(this, CanvasLoaderComponentController);
    console.log(this);
    this.loader = false;
  } };